var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDotsGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.167 2.333a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667m5.833 0A1.833 1.833 0 1 0 10 6a1.833 1.833 0 0 0 0-3.667m5.833 0a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667M4.167 8.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666m5.833 0a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666m5.833 0a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666M4.167 14a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667M10 14a1.833 1.833 0 1 0 0 3.667A1.833 1.833 0 0 0 10 14m5.833 0a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667"
})));
SvgDotsGrid.displayName = "SvgDotsGrid";
export { SvgDotsGrid as ReactComponent };
export default SvgDotsGrid;